export default {
  getPatientInfoByCondition: '/patient/api/obtainPatientUp', // 就诊人列表
  getCardInfoByCondition: '/patient/api/pullHosCardsUp', // 就诊卡列表
  receiveHealthyCard: '/patient/api/registerHealthCard/{0}', // 领取电子健康卡
  getHealthyCardImageToBase64: '/patient/api/getImageToBase64/{0}/{1}', // 电子健康卡二维码
  getCardBalance: '/patient/api/obtainCardBalanceUpV2', // 就诊卡 or 住院卡余额
  modifyPatientInfo: '/patient/api/updatePatientUpV2', // 修改就诊人信息
  deletePatientInfo: '/patient/api/deletePatientUp', // 删除就诊人信息
  createPatientInfo: '/patient/api/createPatientUp', // 新增就诊人信息
  relateHealthCardByHealthCode: '/patient/api/getHealthCardByHealthCode/{0}/{1}', // 关联电子健康卡信息
  getIdCardSerialByOcr: '/patient/api/getOcrInfo-new/{0}', // 识别身份证信息（OCR）
  getOrderIdByOutAppId: '/patient/api/getOrderIdByOutAppId/{0}/{1}', // 卡包订单 ID
  unboundHealthCard: '/patient/api/unBindCardUp/{0}/{1}/{2}/{3}/{4}', // 解绑电子健康卡信息
  verifyBindHealthCardInfo: '/patient/api/getBindIsNoUp/{0}/{1}/{2}', // 是否电子健康卡
  togetherHealthCardHospital: '/patient/api/bindHospitalCardUp/{0}', // 关联电子健康卡与医院
  createPatientCardInfo: '/patient/api/addOnlinePatientUp', // 在线建档
  exchangeCard: '/patient/api/switchPatCardInfo',
  verifyCard: '/patient/api/checkCardNoV2',
  createPatientInfoByInputCard: '/patient/api/newCreateCard', // 新增就诊人信息（通过手输卡号）
  getHealthCardInfoByIdCardSerial: '/patient/api/getHealthCardV2', // 用户电子健康卡信息（通过身份证号）
  bindCardInfo: '/patient/api/createCardInfoUp', // 绑定就诊卡信息
  unboundCardInfo: '/patient/api/unbindCardInfoUpV2', // 解绑就诊卡信息
  reportHealthyCardInfo: '/patient/api/reportHISData', // 上报电子健康卡信息
  getHospitalCardCodeByPatientId: '/patient/api/queryCardByPatId',
  getHisPhoneByCardInfo: '/patient/api/getHisPhoneByCardInfo', // 调取患者院内卡绑定的手机号
  modifyHisPhoneByCardInfo: '/patient/api/updateHisPhoneByCardInfo', // 修改患者院内卡绑定的手机号
  getElectronicIdCardCode: '/patient/api/queryCardByCardNo', // 调取电子身份证二维码（可设置宽高）
  updatePatientExpand: '/patient/api/updatePatientExpand', // 修改就诊人拓展信息
  upgradeCreatePatientInfo: '/patient/api/v2/createPatientUp', // [2.0] 只添加就诊人/住院人
  upgradeBindCardInfo: '/patient/api/v2/createCardInfoUp', // [2.0] 绑卡
  upgradeCreatePatientCardInfo: '/patient/api/v2/addOnlinePatientUp', // [2.0] 在线建档
  upgradeModifyPatientInfo: '/patient/api/v2/updatePatientUp', // [2.0] 修改就诊人信息
  upgradeReceiveHealthyCard: '/patient/api/v2/registerHealthCard' // [2.0] 注册电子健康卡
};
